module.exports = __webpack_public_path__ + "fonts/AvenirNext-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Avenir_Next/AvenirNext-Medium.woff2
// module id = 3473
// module chunks = 0